(function () {
  function selectedId() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return params.get('variant');
    var input = document.querySelector('product-info [name="id"], form[action*="/cart/add"] [name="id"], [name="id"]');
    return input && input.value;
  }
  function leadMap() {
    var node = document.querySelector('[data-variant-lead-map]');
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (e) { return {}; }
  }
  function apply() {
    var id = selectedId();
    var text = leadMap()[String(id)];
    if (!text) return;
    document.querySelectorAll('[data-variant-lead-target]').forEach(function (el) {
      el.textContent = text;
    });
    document.querySelectorAll('.icon-with-text__item').forEach(function (li) {
      if (!/special order|business days|made to order|1-2 business/i.test(li.textContent)) return;
      var span = li.querySelector('span');
      if (span) span.innerHTML = '<strong>' + text + '</strong>';
    });
  }
  function later() { setTimeout(apply, 30); setTimeout(apply, 200); setTimeout(apply, 600); }
  document.addEventListener('variant:changed', later);
  document.addEventListener('variant:change', later);
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'id' || e.target.closest('.product-form__input'))) later();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.product-form__input, variant-selects, .variant-picker')) later();
  });
  window.addEventListener('popstate', later);
  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    try {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, later);
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, later);
    } catch (e) {}
  }
  var last = null;
  setInterval(function () {
    var id = selectedId();
    if (id && id !== last) { last = id; apply(); }
  }, 250);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
